import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ProjectDetail from "@/views/ProjectDetail.vue";
import About from "@/views/About.vue";
import Contact from "@/views/contact.vue";
import Projects from "@/views/Projects.vue";
import Blogs from "@/views/Blogs.vue";
import BlogsDetail from "@/views/BlogsDetail.vue";
import NotFound from "@/views/NotFound.vue";

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/about',
        name: 'about',
        component: About
    },
    {
        path: '/contact',
        name: 'contact',
        component: Contact
    },
    {
        path: '/projects',
        name: 'Projects',
        component: Projects
    },
    {
        path: '/projects/:str',
        name: 'ProjectDetail',
        component: ProjectDetail
    },
    {
        path: '/blogs',
        name: 'Blogs',
        component: Blogs
    },
    {
        path: '/blogs/:str',
        name: 'BlogDetail',
        component: BlogsDetail
    },
    {
        path: '/:pathMatch(.*)*', // 使用通配符匹配任何路径
        name: 'NotFound',
        component: NotFound
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    //

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
